/**
 * Singleton shared IntersectionObserver.
 * All LazyImage instances register with one observer instead of creating their own.
 */

const callbacks = new WeakMap();
let observer = null;

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const cb = callbacks.get(entry.target);
            if (cb) {
              cb();
              observer.unobserve(entry.target);
              callbacks.delete(entry.target);
            }
          }
        }
      },
      { threshold: 0.1 }
    );
  }
  return observer;
}

/**
 * Observe an element. When it enters the viewport, `callback` fires once
 * and the element is automatically unobserved.
 * @returns {Function} cleanup — call to unobserve early (e.g. on unmount)
 */
export function observe(element, callback) {
  const obs = getObserver();
  callbacks.set(element, callback);
  obs.observe(element);
  return () => {
    obs.unobserve(element);
    callbacks.delete(element);
  };
}
